// api/lectures.js
// 講義情報に関するAPIを実装する

import Api from './api_base'

export default {
  get: () => {
    return Api.get('/lectures')
  },
  getById: (id) => {
    return Api.get('/lectures/' + id)
  },
  getByUserId: (userId) => {
    return Api.get('/lectures', {
      params: {
        user_id: userId
      }
    })
  },
  post: (lecture) => {
    return Api.post('/lectures', lecture)
  },
  delete: (id) => {
    return Api.delete('/lectures/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/lectures.js